<template>
  <el-form :inline="true" class="demo-form-inline">
        <!-- <el-form-item label="账户名称：">
            <el-input v-model="formInline.loginName" placeholder="请输入账户名称"></el-input>
        </el-form-item> -->
        <el-form-item label="手机号码：">
            <el-input v-model="formInline.phoneNumber" placeholder="请输入手机号码"></el-input>
        </el-form-item>
        <el-form-item label="车牌号：">
            <el-input v-model="formInline.licensePlate" placeholder="请输入车牌号"></el-input>
        </el-form-item>
        <el-form-item label="状态：">
            <el-select style="width: 200px;" v-model="formInline.accountStatus" filterable placeholder="请选择">
                <el-option
                v-for="item in typeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search()">搜索</el-button>
          <!-- <el-button type="primary">导出</el-button> -->
        </el-form-item>
    </el-form>
    <el-table class="table_wrapper" :data="tableData" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
      <el-table-column label="ID" width="80">
        <template #default="scope">
          <div>
            <span>{{scope.row.id}}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="账号" width="140" show-overflow-tooltip>
        <template #default="scope">
          <div>
            <span>{{ scope.row.loginName }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="姓名" width="140">
        <template #default="scope">
          <div>
            <span>{{ scope.row.name || '--' }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="手机号" width="140">
        <template #default="scope">
          <div>
            <span>{{ scope.row.phoneNumber || '--' }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="用户类型" width="150">
        <template #default="scope">
          <div>
            <span>{{ modeFilter(scope.row.userType) }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="100">
        <template #default="scope">
          <div>
            <span>{{ statusFilter(scope.row.accountStatus) }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="车牌号" show-overflow-tooltip>
        <template #default="scope">
          <div>
            <span>{{ scope.row.licensePlate || '--' }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="注册时间" width="200">
        <template #default="scope">
          <div>
            <span>{{ scope.row.createTime || '--' }}</span>
          </div>
        </template>
      </el-table-column>
      
      <el-table-column label="操作" width="300" fixed="right">
        <template #default="scope">
          <el-button size="small" type="success" @click="handleDetail(scope.$index, scope.row)">
            查看详情
          </el-button>
          <el-button
            size="small"
            type="success"
            v-if="scope.row.accountStatus === 2"
            @click="handleUnfreeze(scope.$index, scope.row)"
          >
            解冻
          </el-button>
          <el-button
            size="small"
            type="primary"
            v-if="scope.row.accountStatus === 0 || scope.row.accountStatus === 1"
            @click="handleFreeze(scope.$index, scope.row)"
          >
            冻结
          </el-button>
          <el-button
            size="small"
            type="danger"
            v-if="scope.row.accountStatus !== 3"
            @click="handleBlacklist(scope.$index, scope.row)"
          >
            加入黑名单
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <Pagination
        v-model:current-page="currentPage"
        v-model:page-size="pageSize"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
    />

    <!-- 用户详情 -->
    <el-drawer
        v-model="drawer"
        title="用户详情"
        direction="rtl"
        size="80%"
    >
    <el-tabs v-model="activeState" class="demo-tabs" @tab-change="handleClick">
          <el-tab-pane label="基本信息" :name="0">
            <el-form :model="detailData" label-position="right" label-width="auto">
              <el-row>
                  <el-col :span="12">
                      <el-form-item label="账号：" prop="">
                          <div>{{detailData.loginName}}</div>
                      </el-form-item>
                  </el-col>
                  <el-col :span="12">
                      <el-form-item label="用户类型：" prop="">
                          <div>
                          <span>{{modeFilter(detailData.userType) || '--'}}</span>
                          </div>
                      </el-form-item>
                  </el-col>
              </el-row>
              <el-row>
                  <el-col :span="12">
                      <el-form-item label="手机号：" prop="">
                          <div>{{detailData.phoneNumber || '--'}}</div>
                      </el-form-item>
                  </el-col>
                  <el-col :span="12">
                      <el-form-item label="账户余额(元)：" prop="">
                          <div>{{detailData.balance !== null && detailData.balance !== undefined ? (detailData.balance === 0 ? '0.00' : detailData.balance) : '--'}}<span style="color: #999;margin-left: 10px;">(备注：其中不可退金额为<i style="color: #f56c6c;">{{detailData.unRefundBalance || '0'}}元</i>，可退金额为<i style="color: #409eff;">{{detailData.refundBalance || '0'}}元</i>)</span></div>
                          <el-button type="primary" v-if="detailData.balance > 0" @click="handleRefund(detailData.unRefundBalance)" style="margin-left: 10px;">退款</el-button>
                        </el-form-item>
                  </el-col>
              </el-row>
              <el-row>
                  <el-col :span="12">
                      <el-form-item label="车牌号：" prop="">
                          <div>{{detailData.licensePlate || '--'}}</div>
                      </el-form-item>
                  </el-col>
                  <el-col :span="12">
                      <el-form-item label="注册时间：" prop="">
                          <div>
                          <span>{{detailData.createTime || '--'}}</span>
                          </div>
                      </el-form-item>
                  </el-col>
              </el-row>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="账单" :name="1">
            <el-row style="margin-bottom: 10px;">
              <el-form-item label="时间范围：">
                <el-radio-group v-model="recordFormInline.timeType" style="margin-right: 10px;">
                  <el-radio :label=1>申请时间</el-radio>
                  <el-radio :label=2>交易时间</el-radio>
                </el-radio-group>
                  <el-date-picker
                      v-model="recordFormInline.tradeTime"
                      value-format="YYYY-MM-DD HH:mm:ss"
                      type="datetimerange"
                      range-separator="至"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间"
                  />
              </el-form-item>
              <el-form-item label="平台订单号：" style="margin-left: 20px;">
                  <el-input v-model="recordFormInline.recordId" placeholder="请输入平台订单号" />
              </el-form-item>
              <el-button style="margin-left: 30px;" type="primary" @click="getBillList(true)">搜索</el-button>
            </el-row>
            <el-table class="table_wrapper" :data="billList" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
              <el-table-column label="平台订单号" width="200" show-overflow-tooltip>
                <template #default="scope">
                  <div>
                    <span>{{scope.row.recordId || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="交易流水号" width="300" show-overflow-tooltip>
                <template #default="scope">
                  <div>
                    <span>{{scope.row.tradeNo || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="交易时间" width="200">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.tradeTime || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="申请时间" width="200">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.applyTime || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="交易金额" width="120">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.tradeAmt || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="支付类型" width="150">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.payTypeStr || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="交易类型" width="120">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.tradeTypeStr || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="交易状态" width="120">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.tradeStatusStr || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="剩余金额(元)">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.remainingAmt || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <Pagination
                v-model:current-page="currentPage2"
                v-model:page-size="pageSize2"
                :total="total2"
                @size-change="handleSizeChange2"
                @current-change="handleCurrentChange2"
            />
          </el-tab-pane>
          <el-tab-pane label="充电记录" :name="2">
            <el-row style="margin-bottom: 10px;">
              <el-form-item label="充电时间：">
                <el-radio-group v-model="chargeFormInline.dateType" style="margin-right: 10px;">
                  <el-radio :label=1>充电开始时间</el-radio>
                  <el-radio :label=2>充电结束时间</el-radio>
                </el-radio-group>
                  <el-date-picker
                      v-model="chargeFormInline.chargeRecordTime"
                      value-format="YYYY-MM-DD HH:mm:ss"
                      type="datetimerange"
                      range-separator="至"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间"
                  />
              </el-form-item>
              <el-form-item label="交易号：" style="margin-left: 20px;">
                  <el-input v-model="chargeFormInline.transactionId" placeholder="请输入交易号" />
              </el-form-item>
              <el-button style="margin-left: 30px;" type="primary" @click="getChargeRecordList(true)">搜索</el-button>
            </el-row>
            <el-table class="table_wrapper" :data="chargeRecordList" :header-cell-style="{'text-align':'left'}" :cell-style="{'text-align':'left'}">
              <el-table-column label="手机号" width="150">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.phoneNumber || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="交易号" width="280" show-overflow-tooltip>
                <template #default="scope">
                  <div>
                    <span>{{scope.row.transactionId || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="车牌号" width="100">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.license || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="场站" width="220" show-overflow-tooltip>
                <template #default="scope">
                  <div>
                    <span>{{scope.row.stationName || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="充电桩" width="100">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.pileIndex + '号桩' || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="充电枪" width="100">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.gunName || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="充电状态" width="200">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.chargeStateStr || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="充电开始时间" width="200">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.beginTime || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="充电结束时间" width="200">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.endTime || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="充电时长(分钟)">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.duration || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="充电量(度)">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.chargeQuantity || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="电费(元)">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.elecFee || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="服务费(元)">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.svcFee || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="折后服务费（元）">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.discSvcFee || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="折后总费用（元）">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.discFee || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="付款金额（元）">
                <template #default="scope">
                  <div>
                    <span>{{scope.row.payAmt || '--'}}</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <!-- 分页 -->
            <Pagination
                v-model:current-page="currentPage3"
                v-model:page-size="pageSize3"
                :total="total3"
                @size-change="handleSizeChange3"
                @current-change="handleCurrentChange3"
            />
          </el-tab-pane>
        </el-tabs>
    </el-drawer>

    <!-- 对话框--冻结、解冻、加入黑名单 -->
    <el-dialog
      v-model="centerDialogVisible"
      title="提示"
      width="500"
      align-center
    >
      <span>{{centerDialogMessage}}</span>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="centerDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="handleConfirm()">确定</el-button>
        </div>
      </template>
    </el-dialog>

    <!-- 对话框--新建、编辑组织 -->
    <el-dialog v-model="dialogFormVisible" :title="dialogTitle" width="500" :close-on-click-modal="false">
        <el-form label-position="right" label-width="auto" :model="addInfo">
        <el-form-item label="企业名称">
          <el-input v-model="addInfo.entName" autocomplete="off" />
        </el-form-item>
        <el-form-item label="计费模式">
          <el-select v-model="addInfo.billingMode" placeholder="请选择">
            <el-option
                v-for="item in billingModeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否统计">
          <el-radio-group v-model="addInfo.statistics">
            <el-radio :label=1>是</el-radio>
            <el-radio :label=0>否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="addInfo.contactPhone" autocomplete="off" />
        </el-form-item>
        <el-form-item label="企业地址">
          <el-input v-model="addInfo.address" autocomplete="off" />
        </el-form-item>
        </el-form>
        <template #footer>
        <div class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取消</el-button>
            <el-button type="primary" @click="saveInfo()">确定</el-button>
        </div>
        </template>
    </el-dialog>

  </template>
  
  <script>
  export default {
  name:'Personal',
  data() {
    return {
      drawer:false,
      centerDialogMessage:'',
      centerDialogType:0,//对话框类型 1：解冻 2：冻结 3：加入黑名单
      formInline:{
        loginName:'',
        phoneNumber:'',
        licensePlate:'',
        accountStatus:''
      },
      typeOptions:[
        {
          label:'全部',
          value:''
        },
        {
          label:'正常',
          value:1
        },
        {
          label:'冻结',
          value:2
        },
        {
          label:'黑名单',
          value:3
        }
      ],
      billingModeOptions:[
        {
          label:'预付费',
          value:1
        },
        {
          label:'后付费',
          value:2
        },
        {
          label:'免费',
          value:3
        }
      ],
      isUpdate:false,
      dialogTitle:'添加企业',
      dialogFormVisible:false,
      currt_id:'', //当前操作id
      tableData:[],
      addInfo:{
        entName:'',
        billingMode:'',
        contactPhone:'',
        address:'',
      },
      total: 0, //总条数
      currentPage: 1, //当前页
      pageSize: 10, //每页显示条数
      centerDialogVisible:false, //删除对话框是否显示
      activeState:0, //当前选中的tab页
      detailData:{}, //用户详情
      billList:[], //账单列表
      recordFormInline:{
        timeType:2,
        tradeTime:[], //交易时间
        recordId:''
      },
      chargeRecordList:[], //充电记录列表
      total2: 0, //总条数2
      currentPage2: 1, //当前页2
      pageSize2: 10, //每页显示条数2
      total3: 0, //总条数3
      currentPage3: 1, //当前页3
      pageSize3: 10, //每页显示条数3
      size:'small',
      chargeFormInline:{
        chargeRecordTime:[],
        dateType:1,
        transactionId:''
      },
    }
  },
  components: {
    
  },
  computed: {
    filteredMessage() {
      // 这里可以实现类似过滤器的转换逻辑
    }
  },
  beforeCreate(){
    
  },
  created(){
    
  },
  mounted(){
    this.getList();
  },
  methods:{
    handleRefund(unRefundBalance){
      //退款
      this.centerDialogVisible = true;
      if(unRefundBalance > 0){
        this.centerDialogMessage = '存在一年外的订单数据，一年外余额为'+unRefundBalance+'元需要手动退款，请确保已经完成手动退款！是否继续退款其余金额？';
      }else{
        this.centerDialogMessage = '确认全部退款？';
      }
      this.centerDialogType = 4;
    },
    refundUser(){
      //退款
      let that = this;
      let param = {
        driverUserId:that.currt_id
      }
      that.$axios.post(that.$store.state.platformApi+"driver/user/refund",JSON.stringify(param)).then(result => {
        if(result.code==200){
          that.$message({
            message: '操作成功',
            type: 'success'
          })
          // 操作成功后，刷新列表
          that.getList();
          that.centerDialogVisible = false;
        }
      })
    },
    handleDetail(index,row){
      //查看详情
      this.drawer = true;
      this.currt_id = row.id;
      this.detailData = JSON.parse(JSON.stringify(row));
    },
    handleClick(tab, event) {
      // console.log(tab, event);
      this.activeState = tab;
      if(this.activeState==1){
        this.getBillList(false);
      }else if(this.activeState==2){
        this.getChargeRecordList(false);
      }
    },
    freezeUser(){
      //冻结、解冻
      let that = this;
      that.$axios.post(that.$store.state.platformApi+"driver/user/set/freeze/"+that.currt_id+"/"+that.centerDialogType,{}).then(result => {
        if(result.code==200){
          that.$message({
            message: '操作成功',
            type: 'success'
          })
          // 操作成功后，刷新列表
          that.getList();
          that.centerDialogVisible = false;
        }
      })
    },
    blacklistUser(){
      //加入黑名单
      let that = this;
      that.$axios.post(that.$store.state.platformApi+"driver/user/set/black/"+that.currt_id,{}).then(result => {
        if(result.code==200){
          that.$message({
            message: '操作成功',
            type: 'success'
          })
          // 操作成功后，刷新列表
          that.getList();
          that.centerDialogVisible = false;
        }
      })
    },
    handleConfirm(){
      //确认操作
      if(this.centerDialogType==1){
        this.freezeUser();
      }else if(this.centerDialogType==2){
        this.freezeUser();
      }else if(this.centerDialogType==3){
        this.blacklistUser();
      }else if(this.centerDialogType==4){
        this.refundUser();
      }
    },
    handleUnfreeze(index,row){
      //解冻
      this.currt_id = row.id;
      this.centerDialogMessage = '确认解冻该用户吗？';
      this.centerDialogVisible = true;
      this.centerDialogType = 1;
    },
    handleFreeze(index,row){
      //冻结
      this.currt_id = row.id;
      this.centerDialogMessage = '确认冻结该用户吗？';
      this.centerDialogVisible = true;
      this.centerDialogType = 2;
    },
    handleBlacklist(index,row){
      //加入黑名单
      this.currt_id = row.id;
      this.centerDialogMessage = '确认把该用户加入黑名单吗？';
      this.centerDialogVisible = true;
      this.centerDialogType = 3;
    },
    handleSizeChange (val) { //每页显示条数
        this.pageSize = val;
        this.currentPage = 1;
        this.getList();
    },
    handleCurrentChange(val) { //当前页
        this.currentPage = val;
        this.getList(); //获取列表
    },
    handleSizeChange2 (val) { //每页显示条数2
        this.pageSize2 = val;
        this.currentPage2 = 1;
        this.getBillList(false);
    },
    handleCurrentChange2(val) { //当前页2
      this.currentPage2 = val;
      this.getBillList(false); //获取账单列表
    },
    handleSizeChange3 (val) { //每页显示条数3
        this.pageSize3 = val;
        this.currentPage3 = 1;
        this.getChargeRecordList(false);
    },
    handleCurrentChange3(val) { //当前页3
      this.currentPage3 = val;
      this.getChargeRecordList(false); //获取充电记录列表
    },
    getBillList(isSearch){
      //获取账单列表
      let that = this;
      let param = {};
      param.driverUserId = that.currt_id;
      param.page = that.currentPage2;
      param.pageSize = that.pageSize2;
      param.timeType = that.recordFormInline.timeType;
      param.recordId = that.recordFormInline.recordId;
      if(isSearch){
        param.page = 1;
      }
      if(that.recordFormInline.tradeTime && that.recordFormInline.tradeTime.length==2){
        param.startDate = that.recordFormInline.tradeTime[0];
        param.endDate = that.recordFormInline.tradeTime[1];
      }
      that.$axios.post(that.$store.state.platformApi+"driver/user/bill",JSON.stringify(param)).then(result => {
        if(result.code==200){
          that.billList = result.data.records;
          that.total2 = result.data.total;
        }
      })
    },
    getChargeRecordList(isSearch){
      //获取充电记录列表
      let that = this;
      let param = {};
      param.driverUserId = that.currt_id;
      param.page = that.currentPage3;
      param.pageSize = that.pageSize3;
      param.dateType = that.chargeFormInline.dateType;
      if(isSearch){
        param.page = 1;
      }
      if(that.chargeFormInline.chargeRecordTime && that.chargeFormInline.chargeRecordTime.length==2){
        param.startTime = that.chargeFormInline.chargeRecordTime[0];
        param.endTime = that.chargeFormInline.chargeRecordTime[1];
      }
      if(that.chargeFormInline.transactionId){
        param.transactionId = that.chargeFormInline.transactionId;
      }
      that.$axios.post(that.$store.state.platformApi+"driver/user/chargeRecord",JSON.stringify(param)).then(result => {
        if(result.code==200){
          that.chargeRecordList = result.data.records;
          that.total3 = result.data.total;
        }
      })
    },
    search(){
      //搜索
      let that = this;
      let param = {};
      param.page = 1;
      param.pageSize = this.pageSize;
      param.loginName = that.formInline.loginName;
      param.phoneNumber = that.formInline.phoneNumber;
      param.licensePlate = that.formInline.licensePlate;
      param.accountStatus = that.formInline.accountStatus;

      that.$axios.post(that.$store.state.platformApi+"driver/user/page",JSON.stringify(param)).then(result => {
        if(result.code==200){
          that.tableData = result.data.records;
          that.total = result.data.total;
        }
      })
    },
    getList(){
      //获取列表
      let that = this;
      let param = {};
      param.page = this.currentPage;
      param.pageSize = this.pageSize;
      param.loginName = that.formInline.loginName;
      param.phoneNumber = that.formInline.phoneNumber;
      param.licensePlate = that.formInline.licensePlate;
      param.accountStatus = that.formInline.accountStatus;

      that.$axios.post(that.$store.state.platformApi+"driver/user/page",JSON.stringify(param)).then(result => {
        if(result.code==200){
          that.tableData = result.data.records;
          that.total = result.data.total;
        }
      })
    },
    modeFilter(value) {
      //过滤函数
      switch (value) {
        case 0:
          return '个人用户';
        case 1:
          return '企业预付费';
        case 2:
          return '企业后付费';
        case 3:
          return '免费';
        default:
          return '其他';
      }
    },
    statusFilter(value) {
      //过滤函数
      switch (value) {
        case 1:
          return '正常';
        case 2:
          return '冻结';
        case 3:
          return '黑名单';
        default:
          return '其他';
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.search_nav{
    width: 100%;
    height: 60px;
}
</style>